/** @jsx jsx */
// eslint-disable-next-line
import React, { Component } from 'react'
import { css, jsx } from '@emotion/core'
import PropTypes from 'prop-types'
import { TextField, withStyles } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import InputAdornment from '@material-ui/core/InputAdornment'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import { Formik } from 'formik'
import { theme } from '../../../constants'

const styles = {}

styles.form = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;
  width: 100%;
`

styles.buttonStyle = {
  background: theme.palette.primary.main,
  color: 'white',
  borderRadius: '8px',
  width: '400px',
  height: '43px'
}

const CssTextField = withStyles({
  color: 'white',
  root: {
    '& label.Mui-focused': {
      color: 'white'
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: `${theme.palette.primary.main} !important`
    },
    '& .Mui-disabled': {
      color: `${theme.palette.primary.main} !important`
    },
    '& .MuiOutlinedInput-input': {
      color: 'white'
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: `${theme.palette.primary.main} !important`,
        borderRadius: '8px',
        width: '400px'
      }
    },
    '& .MuiOutlinedInput-adornedEnd': {
      borderRadius: '8px',
      paddingRight: '0px'
    }
  }
})(TextField)

class LoginForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showPassword: false
    }

    this.formInitialValues = { email: '', password: '' }
  }

  onToggleShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword })
  }

  validateForm = values => {
    const errors = {}
    if (!values.password) {
      errors.password = window.I18n.t('common.required')
    }

    if (!values.email) {
      errors.email = window.I18n.t('common.required')
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
      errors.email = window.I18n.t('login.invalidEmail')
    }

    return errors
  }

  render() {
    return (
      <Formik
        initialValues={this.formInitialValues}
        validate={this.validateForm}
        onSubmit={this.props.onSubmit}
      >
        {formik => (
          <form css={styles.form} noValidate onSubmit={formik.handleSubmit} method="POST">
            <CssTextField
              fullWidth
              label={window.I18n.t('login.enterYourEmail')}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
              type="email"
              name="email"
              InputProps={{ autoComplete: 'new-email' }}
              variant="outlined"
              error={formik.errors.email && formik.touched.email && !!formik.errors.email}
              helperText={formik.errors.email && formik.touched.email && formik.errors.email}
            />
            <CssTextField
              fullWidth
              label={window.I18n.t('login.enterYourPassword')}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.password}
              type={this.state.showPassword ? 'text' : 'password'}
              name="password"
              variant="outlined"
              color="primary"
              error={formik.errors.password && formik.touched.password && !!formik.errors.password}
              helperText={
                formik.errors.password && formik.touched.password && formik.errors.password
              }
              InputProps={{
                autoComplete: 'new-password',
                endAdornment: (
                  <InputAdornment position="end" css={{ position: 'absolute', right: '-10px' }}>
                    {formik.values.password && (
                      <IconButton
                        color="secondary"
                        aria-label="toggle password visibility"
                        onClick={this.onToggleShowPassword}
                      >
                        {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    )}
                  </InputAdornment>
                )
              }}
            />

            <Button
              variant="contained"
              fullWidth
              disabled={formik.isSubmitting}
              type="submit"
              style={styles.buttonStyle}
            >
              {formik.isSubmitting ? (
                <CircularProgress color="inherit" size={24} thickness={4} />
              ) : (
                <span>{window.I18n.t('common.continue')}</span>
              )}
            </Button>
          </form>
        )}
      </Formik>
    )
  }
}

LoginForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  goToReset: PropTypes.func.isRequired,
  goToSignUp: PropTypes.func.isRequired
}

export default LoginForm
